const AddHuman = () => import(/* webpackPrefetch: true, webpackChunkName: "add-human" */ '@/app/views/auth-view/components/auth-register/components/add-human/add-human.vue');
const AddHumanWalkerSitter = () => import(/* webpackPrefetch: true, webpackChunkName: "add-human-walker-sitter" */ '@/app/views/auth-view/components/auth-register/components/add-human-walker-sitter/add-human-walker-sitter.vue');
const AddPet = () => import(/* webpackPrefetch: true, webpackChunkName: "add-pet" */ '@/app/views/main-view/_shared/_components/add-pet/add-pet.vue');
const SelectPreferredBreeds = () => import(/* webpackPrefetch: true, webpackChunkName: "select-preffered-breeds" */ '@/app/views/auth-view/components/auth-register/components/select-preferred-breeds/select-preferred-breeds.vue');

export default {
    name: 'AuthRegisterContainer',
    components: {
        AddPet,
        AddHuman,
        AddHumanWalkerSitter,
        SelectPreferredBreeds
    },
   
    data() {
        return {
            activeComponent: 'add-pet'
        }
    },
    watch: {
        activeComponent: {
            immediate: true,
            handler(activeComponent) {
                if(this.$route.path === "/create-account" && activeComponent !== "add-human"){
                    this.setActiveComponent("add-human"); 
                }
                this.$emit('setDesktopHeader', activeComponent);
            }
        }
    },
    methods: {
        setActiveComponent(activeComponent) {
            this.activeComponent = activeComponent;
        }
    }
}